import Vue from 'vue'
import App from './App.vue'
import VueTippy, { TippyComponent } from 'vue-tippy';

Vue.use(VueTippy, {
  arrow: true,
  animateFill: false,
  theme: 'blue',
  maxWidth: 260
});
Vue.component('tippy', TippyComponent);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#shelving_calculator')
